import { Box, BoxProps, styled } from '@mui/material';

interface BoxExtendedProps extends BoxProps {
	isopen?: boolean;
}

export const EditUserStoriesHeader = styled(Box)<BoxExtendedProps>(() => ({
	position: 'relative',
	width: '100%',
	marginBottom: '10px',
	padding: '0',
}));
